import { render, staticRenderFns } from "./TrainingsCombo.vue?vue&type=template&id=4bb9ec4b&"
import script from "./TrainingsCombo.vue?vue&type=script&lang=js&"
export * from "./TrainingsCombo.vue?vue&type=script&lang=js&"
import style0 from "./TrainingsCombo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCombobox,VContainer})
